import React, { PureComponent } from 'react'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'

class DeleteQuestion extends PureComponent {
    render() {
        const {
            question, show, onClose, onSelect,
        } = this.props

        return (
            <Modal
                show={show}
                onClose={() => { onClose() }}
            >
                <div className="form-header">
                    <i className="fa-light fa-circle-exclamation fa-lg" />
                    <h2>{i18n.t('questionLibrary.question.deleteModal.title', 'Delete question')}</h2>
                    <p className="desc">
                        {i18n.t('questionLibrary.question.deleteModal.description', 'Are you sure you want to remove this mandatory question?')}
                    </p>
                </div>
                <div className="btn-wrapper">
                    <Button
                        cssClass="button primary regular"
                        onClick={() => { onClose(false) }}
                        label={i18n.t('questionLibrary.question.deleteModal.cancel', 'Cancel')}
                    />
                    <Button
                        cssClass="button error regular"
                        onClick={() => { onSelect(question) }}
                        label={i18n.t('questionLibrary.question.deleteModal.confirm', 'Delete')}
                        icon="fa-thin fa-circle-xmark"
                        style={{ justifyContent: 'center' }}
                    />
                </div>
            </Modal>
        )
    }
}

export default DeleteQuestion
